import { z } from 'zod';
/**
 * Search — closed result-kind enum for the global search-results overlay.
 *
 * The overlay's left-rail filter and `<SearchResultRow>` rows draw from
 * this set. Promoted out of `apps/web/src/components/search-results.tsx`
 * per the CLAUDE.md "Closed string sets are enums" rule so the same
 * vocabulary is available to any backend synthesis surface that produces
 * search rows (e.g. a future `POST /api/search` endpoint) without
 * re-declaring the literal tuple.
 *
 * Naming note: `SearchResultKind` is the row-level kind — the value that
 * appears on `SearchResultRow.kind`. `SearchResultFilter` is the filter
 * pivot for the rail and is `SearchResultKind | 'all'`. `'all'` is a
 * filter-only sentinel — rows never carry `kind: 'all'`, so the counts
 * map and rail filter stay honest.
 */
export const SearchResultKind = z.enum([
    'people',
    'dossiers',
    'notes',
    'signals',
    'decisions',
    'rocks',
    'playbooks',
]);
/** Sentinel for the rail's "All" pivot — never appears on a row. */
export const SEARCH_RESULT_FILTER_ALL = 'all';
/**
 * Filter pivot for the overlay's left rail. Includes the `'all'`
 * sentinel; row data never carries this value.
 */
export const SearchResultFilter = z.enum([SEARCH_RESULT_FILTER_ALL, ...SearchResultKind.options]);
